import script from "./templateAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./templateAdd.vue?vue&type=script&setup=true&lang=js"

import "./templateAdd.vue?vue&type=style&index=0&id=fdfff1b6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdfff1b6"]])

export default __exports__